export default "__VITE_ASSET__BOBajnyp__"